<template>
	<div class="wrapper" :class="{ 'nav-open': $sidebar.showSidebar }">
		<RePhoneBar />
		<ReBacktrace :masBackTrace="$GVO.masBackTrace" v-if="$GVO.masBackTrace.length>0"></ReBacktrace>
		<notifications></notifications>
		<sidebar-fixed-toggle-button />
		<side-bar
			:background-color="sidebarBackground"
			:short-title="$t('sidebar.shortTitle')"
			:title="'/img/icons/Logo_reactor_txt_only_W.svg'"
			:logo="'/img/icons/Logo_reactor_W.svg'"
			:sidebarLinks="masMenu"
			@videoParents="videoReactorParents"
			@videoChildren="videoReactorChildren"
		>
		</side-bar>
		<!--Share plugin (for demo purposes). You can remove it if don't plan on using it-->
		<sidebar-share :background-color.sync="sidebarBackground"> </sidebar-share>
		<div class="main-panel" :data="sidebarBackground">
			<dashboard-navbar :videoParents="videoLearnReactorParents" :videoChildren="videoLearnReactorChildren" ></dashboard-navbar>
			<router-view name="header"></router-view>

			<div
				:class="{ content: !$route.meta.hideContent }"
				@click="toggleSidebar"
			>
				<zoom-center-transition :duration="200" mode="out-in">
					<!-- your content here -->
					<router-view></router-view>
				</zoom-center-transition>
			</div>
			<content-footer v-if="!$route.meta.hideFooter"></content-footer>
		</div>
		<Modals></Modals>
	</div>
</template>
<script>
/*
name: $t('sidebar.pricing') берёт от туда -> src/locales/ru.json
*/
/* eslint-disable no-new */
var ps = [];
import PerfectScrollbar from 'perfect-scrollbar';
//import 'perfect-scrollbar/css/perfect-scrollbar.css';
import SidebarShare from './SidebarSharePlugin';
function hasElement(className) {
	return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
	if (hasElement(className)) {
		SGVO.ps.push(new PerfectScrollbar(`.${className}`));
		//console.log(ps);
	} else {
		// try to init it later in case this component is loaded async
		setTimeout(() => {
			initScrollbar(className);
		}, 100);
	}
}

import DashboardNavbar from './DashboardNavbar.vue';
import ContentFooter from './ContentFooter.vue';
// import DashboardContent from './Content.vue';
import SidebarFixedToggleButton from './SidebarFixedToggleButton.vue';
import { /*SlideYDownTransition,*/ ZoomCenterTransition } from 'vue2-transitions';
import RePhoneBar from 'src/our_components/RePhoneBar.vue';
import ReBacktrace from "src/our_components/ReBacktrace.vue";

export default {
	components: {
		DashboardNavbar,
		ContentFooter,
		SidebarFixedToggleButton,
		// DashboardContent,
		// SlideYDownTransition,
		ZoomCenterTransition,
		SidebarShare,
		RePhoneBar,
		ReBacktrace
	},
	data() {
		return {
			sidebarBackground: 'vue', //vue|blue|orange|green|red|primary
			masMenu:[],
			videoLearnReactorParents: 'none',
			videoLearnReactorChildren: 'none',
		};
	},
	watch:{
		
	},
	methods: {
		toggleSidebar() {
			if (this.$sidebar.showSidebar) {
				this.$sidebar.displaySidebar(false);
			}
		},
		initScrollbar() {
			let docClasses = document.body.classList;
			let isWindows = navigator.platform.startsWith('Win');
			if (isWindows) {
				// if we are on windows OS we activate the perfectScrollbar function
				initScrollbar('sidebar');
				initScrollbar('main-panel');
				initScrollbar('sidebar-wrapper');

				docClasses.add('perfect-scrollbar-on');
			} else {
				docClasses.add('perfect-scrollbar-off');
			}
		},
		findCurrentMenu(){
			let find=false;
			let currPath = location.pathname;
			let path = '';
			// console.log('menu',this.masMenu);
			for(let menu of this.masMenu){
				if(!menu.path) continue;
				path=menu.path.replace(/\?.*/,'');
				if(path == currPath){
					this.videoReactorParents(menu.videoUrl);
					return;
				}
				if(menu.children){
					for(let menuC of menu.children){
						path=menuC.path.replace(/\?.*/,'');
						if(path == currPath){
							this.videoReactorChildren(menuC.videoUrl);
							return;
						}

					}
				}
			}
		},
		getMenu(){
			this.$GVO.ApiCall('GET',{obj:'menu'})
				.then((objApi) => {
					// console.log('menu',objApi);
					if(objApi.success === true){
						if(objApi.data.length > 0){
							this.masMenu = objApi.data;
							this.findCurrentMenu();
						}
					}
				}).catch(errorObjApi => console.error(errorObjApi));
		},
		videoReactorParents(e){
			// this.videoObj.push(e);
			// console.log('videoReactorParents', e);
			this.videoLearnReactorParents = 'none';
			if(e == 'none') {
				this.videoLearnReactorParents = 'none';
			} else {
				this.videoLearnReactorParents = e;
				// console.log('this.videoLearnReactorParents', this.videoLearnReactorParents);
			}
			
		},
		videoReactorChildren(e){
			// this.videoObj.push(e);
			// console.log('videoReactorChildren', e);
			this.videoLearnReactorChildren = 'none';
			if(e == 'none') {
				this.videoLearnReactorChildren = 'none';
			} else {
				this.videoLearnReactorChildren = e;
				// console.log('this.videoLearnReactorChildren', this.videoLearnReactorChildren);
			}
		},

	},
	mounted() {
		//this.initScrollbar();
		this.getMenu();
	},
	created() {
		//this.getMenu();
	}
};
</script>
<style lang="scss">
	$scaleSize: 0.95;
	@keyframes zoomIn95 {
		from {
			opacity: 0;
			transform: scale3d($scaleSize, $scaleSize, $scaleSize);
		}
		to {
			opacity: 1;
		}
	}

	.main-panel .zoomIn {
		animation-name: zoomIn95;
	}

	@keyframes zoomOut95 {
		from {
			opacity: 1;
		}
		to {
			opacity: 0;
			transform: scale3d($scaleSize, $scaleSize, $scaleSize);
		}
	}

	.main-panel .zoomOut {
		animation-name: zoomOut95;
	}

	.sidebar .logo a.logo-mini img {
		background-color: transparent;
	}
	.logoTxt-img img {
		height: 37px;
	}
	.sidebar::before, .off-canvas-sidebar::before {content: none;}  

	.swal2-popup {width: fit-content;}
	.ytp-chrome-top {display: none!important}
	.ytp-impression-link{display: none!important}

</style>
